import { connect } from "react-redux";
import Calendar from "../../Calendar/Calendar";
import { getDateRange } from "../../../utils";
import Reveal from "../Reveal";
import Section from "./Section";

/**
 * The wedding month with the celebration days marked, right after the first
 * page, in the venue section's arch-shaped double border (without its image).
 */
const CalendarSection = ({ events }) => {
  const { fromDate, toDate } = getDateRange(events || []);
  if (!fromDate) return null;

  return (
    <Section className="rm-calendar" label="Wedding calendar" kicker="Mark Your Calendar" title="Save the Date">
      <Reveal effect="fade" className="rm-calendar__arch" delay={0.1}>
        <div className="rm-calendar__card">
          <Calendar fromDate={fromDate} toDate={toDate} />
        </div>
      </Reveal>
    </Section>
  );
};

const mapStateToProps = (state) => ({
  events: state.inviteDetails.invite?.events,
});

export default connect(mapStateToProps)(CalendarSection);
